import React from 'react';
import { CCard, CCardBody, CCol, CRow, CTable, CTableRow, CTableDataCell, CTableHead, CTableHeaderCell, CTableBody } from '@coreui/react';

export const StatsSkeleton = () => (
    <CRow className="g-3">
        {[1, 2, 3, 4, 5, 6].map((i) => (
            <CCol xs={12} sm={6} md={4} lg={2} key={i}>
                <div className="stats-card p-3">
                    <div className="d-flex align-items-center mb-2">
                        <div className="skeleton-item" style={{ width: '28px', height: '28px', borderRadius: '50%' }}></div>
                        <div className="skeleton-item ms-2" style={{ width: '60px' }}></div>
                    </div>
                    <div className="skeleton-item" style={{ width: '40px', height: '30px' }}></div>
                </div>
            </CCol>
        ))}
    </CRow>
);

export const TableSkeleton = () => (
    <div className="contenedor-scroll-tabla-list" style={{ height: '400px' }}>
        <CTable striped small align="middle" className="mb-0 ctable-list" hover responsive style={{ width: '100%' }}>
            <CTableHead className="sticky-header-detail">
                <CTableRow>
                    <CTableHeaderCell className="fgh">ID</CTableHeaderCell>
                    <CTableHeaderCell className="fgh">Tipo</CTableHeaderCell>
                    <CTableHeaderCell className="fgh text-center">Latitud/Longitud</CTableHeaderCell>
                    <CTableHeaderCell className="fgh text-center">Frame</CTableHeaderCell>
                    <CTableHeaderCell className="fgh">Dirección</CTableHeaderCell>
                    <CTableHeaderCell className="fgh text-center">Acciones</CTableHeaderCell>
                </CTableRow>
            </CTableHead>
            <CTableBody>
                {Array.from({ length: 8 }).map((_, i) => (
                    <CTableRow key={i}>
                        <CTableDataCell className="text-center"><div className="skeleton-item" style={{ width: '20px' }}></div></CTableDataCell>
                        <CTableDataCell><div className="skeleton-item" style={{ width: '120px' }}></div></CTableDataCell>
                        <CTableDataCell className="text-center"><div className="skeleton-item" style={{ width: '80px' }}></div></CTableDataCell>
                        <CTableDataCell className="text-center"><div className="skeleton-item" style={{ width: '40px' }}></div></CTableDataCell>
                        <CTableDataCell><div className="skeleton-item" style={{ width: '200px' }}></div></CTableDataCell>
                        <CTableDataCell className="text-center"><div className="skeleton-item" style={{ width: '60px' }}></div></CTableDataCell>
                    </CTableRow>
                ))}
            </CTableBody>
        </CTable>
    </div>
);

export const InfoSkeleton = () => (
    <CCard className="premium-card p-4">
        <div className="skeleton-item mb-4" style={{ width: '150px', height: '24px' }}></div>
        <CRow>
            <CCol md={6}>
                {[1, 2, 3, 4].map(i => (
                    <div key={i} className="mb-3">
                        <div className="skeleton-item mb-1" style={{ width: '80px', height: '14px' }}></div>
                        <div className="skeleton-item" style={{ width: '180px', height: '18px' }}></div>
                    </div>
                ))}
            </CCol>
            <CCol md={6}>
                {[1, 2, 3].map(i => (
                    <div key={i} className="mb-3">
                        <div className="skeleton-item mb-1" style={{ width: '80px', height: '14px' }}></div>
                        <div className="skeleton-item" style={{ width: '180px', height: '18px' }}></div>
                    </div>
                ))}
            </CCol>
            <CCol xs={12} className="mt-3">
                <div className="skeleton-item mb-1" style={{ width: '100px', height: '14px' }}></div>
                <div className="skeleton-item" style={{ width: '100%', height: '80px' }}></div>
            </CCol>
        </CRow>
    </CCard>
);
